import { Component, OnInit, HostListener, ChangeDetectorRef, Renderer2, AfterViewInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ConstantsService, LookupsService, RequestTypesEnum, SessionService, StepsIdEnum } from '@app/base/core';
import { CanComponentDeactivate } from '@app/base/shared';
import { MultistepsService } from '@app/modules/applicant/base';
import { AlertService } from '@app/base/alerts/alert.service';
@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.css']
})
export class InformationComponent implements OnInit, AfterViewInit, CanComponentDeactivate {
  form: FormGroup;
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  requestTypeEnum: typeof RequestTypesEnum = RequestTypesEnum;
  showPhoneExtension = false;
  siteContactCount = true;
  alertMsg: any = [];


  @HostListener('window:beforeunload', ['$event']) onBeforeUnload(event) {
    event.preventDefault();
    // Specially for chrome...
    event.returnValue = this.constantsSvc.changes;
  }

  constructor(
    public wizardSvc: MultistepsService,
    public sessionSvc: SessionService,
    public constantsSvc: ConstantsService,
    public lookupSvc: LookupsService,
    public alertService: AlertService,
    private detectChange: ChangeDetectorRef,
    private renderer: Renderer2
    // private formBuilder: FormBuilder
  ) {
    this.wizardSvc.syncActiveStep(StepsIdEnum.INFORMATION);
  }
  ngOnInit() {
    // Loads BCA Lookup values
    this.lookupSvc.loadBcaLookups(this.wizardSvc.paramRequestType, this.wizardSvc.serviceAddress.state.short_name);
    // Loads Common Lookup Values
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      // Loads banner Message
      if (val) {
        this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === this.constantsSvc.bannermsgInfoComp));
        this.alertService.info(this.alertMsg.message);
      }
    });
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.INFORMATION).form;
    const phoneType = this.form.controls['phoneNumberType'].value;
    if (phoneType && phoneType.id === 2) { this.showPhoneExtension = true; }

    const formArray = <FormArray>this.form.controls['contactTypeDetails'];
    if (formArray.length > 4) {
      this.siteContactCount = false;
    } else {
      this.siteContactCount = true;
    }

  }
  ngAfterViewInit() {
    this.disableTextAndBothOtions();
  }
  next() {
    this.wizardSvc.nextStep(); // To go to Next step/page
  }
  back() { this.wizardSvc.previousStep(); } // To go to Previous step/page
  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState: RouterStateSnapshot) {
    return this.wizardSvc.canDeactivateStep(route, state, nextState);
  }

  // Applicant address same as service address
  siteContactToggle(eve: any) {
    const siteContactSame = <FormControl>(this.form.get('siteContactSame'));
    this.cloneSiteContact(siteContactSame.value);
  }
  // Code to clone same address as service address based on input true/false
  cloneSiteContact(same: boolean) {
    const siteData = (<FormArray>this.form.controls['contactTypeDetails']).controls[0];
    if (same) {
      siteData.patchValue({
        firstName: this.form.controls['firstName'].value,
        lastName: this.form.controls['lastName'].value,
        siteContactPhoneNumber: this.form.controls['applicantPhoneNumber'].value,
        emailAddress: this.form.controls['emailAddress'].value,
        companyName: this.form.controls['companyName'].value,
        siteContactPhoneNumberExtension: this.form.controls['applicantPhoneNumberExtension'].value
      });
    } else {
      siteData.patchValue({
        firstName:  '',
        lastName: '',
        siteContactPhoneNumber: '',
        siteContactEmailAddress: '',
        companyName: '',
        siteContactPhoneNumberExtension: '',
        emailAddress: ''
      });
    }
    this.form.updateValueAndValidity();
  }

  // #Information page Functions Region
  // Add FormGroup to Contact Details form Array in Information page.
  add() {
    const formArray = <FormArray>this.form.controls['contactTypeDetails'];
    formArray.push(new FormGroup({
      siteContactType: new FormControl(null, [Validators.required]),
      companyName: new FormControl(''),
      siteContactTypeOthers: new FormControl(''),
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      siteContactPhoneNumber: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)]),
      siteContactPhoneNumberExtension: new FormControl('',
        [Validators.pattern(this.constantsSvc.phoneNumberExtensionPattern), Validators.maxLength(6)]),
      emailAddress: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.emailPattern)])
    })
    );
    if (formArray.length > 4) {
      this.siteContactCount = false;
    }
  }
  // Delete FormGroup from Contact Details form Array based on the input  Array index id
  delete(id: number) {
    const formArray = <FormArray>this.form.controls['contactTypeDetails'];
    formArray.removeAt(id);

    if (formArray.length < 5) {
      this.siteContactCount = true;
    }
  }
  // Like to Receive Test Message or not
  isLiketoReceiveTestMessagesToggle($event) {
    const isLiketoReceiveTestMessages = <FormControl>(this.form.get('isLiketoReceiveTestMessages'));

    if (isLiketoReceiveTestMessages.value) {
      this.form.controls['applicantPhoneNumber1'].setValidators([Validators.required,
      Validators.pattern(this.constantsSvc.phoneNumberPattern)]);
      this.form.controls['applicantPhoneNumber1'].patchValue(this.form.controls['applicantPhoneNumber'].value);
    } else {
      this.form.controls['applicantPhoneNumber1'].clearValidators();
      this.form.controls['applicantPhoneNumber1'].reset('');
      this.form.controls['applicantPhoneNumber2'].reset('');
      this.form.controls['applicantPhoneNumber3'].reset('');
    }
    this.form.updateValueAndValidity();


  }
  // PhoneType selection
  onPhoneTypeSelect(item: any, ) {
    if (item.id === 2) { this.showPhoneExtension = true; } else {
      this.showPhoneExtension = false;
      this.form.controls['applicantPhoneNumberExtension'].reset();
    }
  }
  // Select Contact Type
  onSelect(item: any, typeDetail: FormGroup) {
    typeDetail.controls['siteContactTypeOthers'].reset();
    typeDetail.controls['siteContactTypeOthers'].clearValidators();
    if (item['id'] === 'O') {
      typeDetail.controls['siteContactTypeOthers'].setValidators(Validators.required);
      typeDetail.controls['siteContactTypeOthers'].updateValueAndValidity({
        onlySelf: true
      });
    } else {
      typeDetail.controls['siteContactTypeOthers'].reset();
      typeDetail.controls['siteContactTypeOthers'].clearValidators();
    }
  }
  //select KMI Communication
  onCommunicationCheck(control) {
    if (control.value == 'Yes' || control.value == 'No' )
      {

      this.form.controls['kmiCommunication'].clearValidators();
    }

  }
  getControlValue(controlName: string) {
    return this.form.get(controlName).value;
  }
  setControlNull(args: any[]) { args.forEach(arg => { this.form.controls[arg].patchValue(null); }); }
  clearValidators(args: any[]) {
    args.forEach(arg => {
      this.form.controls[arg].clearValidators();
      this.form.controls[arg].updateValueAndValidity();
    });
  }
  setRequiredValidator(args: any[]) {
    args.forEach(arg => {
      this.form.controls[arg].setValidators([Validators.required]);
      this.form.controls[arg].updateValueAndValidity();
    });
  }

  setEmailCheckValidator(controlName: any) {
      this.form.controls[controlName].setValidators([Validators.required,Validators.pattern(this.constantsSvc.emailPattern)]);
    this.form.controls[controlName].updateValueAndValidity();
  }

  setPhoneCheckValidator(controlName: any) {
      this.form.controls[controlName].setValidators([Validators.required,Validators.pattern(this.constantsSvc.phoneNumberPattern)]);
    this.form.controls[controlName].updateValueAndValidity();
  }

  onCommunicationCheck1(control) {
    if (control.value == 'Yes' || control.value == 'No') {
      this.form.controls['kmiCommunication'].clearValidators();
      this.form.controls['kmiCommunication'].updateValueAndValidity();
    }
    this.detectChange.detectChanges();
  }
  
  onQuestionCheck1(control) {
    switch (control.controlName) {

      case 'kmiCommunication':
        this.setControlNull(['kmiReceive', 'kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);
        this.clearValidators(['kmiReceive', 'kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);

        if (control.value === this.constantsSvc.Yes) {
        
          this.setRequiredValidator(['kmiReceive', 'kmiFrequency']);
          this.disableTextAndBothOtions();
        }

        else {

          this.clearValidators(['kmiReceive', 'kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);

        }
        break;
      case 'kmiReceive':
        this.setControlNull(['kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);
        this.clearValidators(['kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);
        if (control.value === 'Email') {
          this.setEmailCheckValidator('kmiEmailAddress');
          this.setRequiredValidator(['kmiFrequency']);
        }
        else if (control.value === 'Text') {
          this.setPhoneCheckValidator('kmiTextNumber');
          this.setRequiredValidator(['kmiFrequency']);
        }
        else if (control.value === 'Both') {
          this.setEmailCheckValidator('kmiEmailAddress');
          this.setPhoneCheckValidator('kmiTextNumber');
          this.setRequiredValidator(['kmiFrequency']);
        }
        break;


      default:
        return;
    }
  }
  disableTextAndBothOtions()
  {
  // Fetch all radio buttons using native JavaScript querySelectorAll
  const radioButtons = document.querySelectorAll('.communication-radio-group input[type="radio"]');
  radioButtons.forEach((radio: HTMLInputElement) => {
   
    if (radio.title === 'Both' || radio.title === 'Text') {
      this.renderer.setProperty(radio, 'disabled', true); 
    }
  });
  }

}
